/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2021 ICEMEDX, Inc.
***********************************************/
import { Injectable, ApplicationRef } from '@angular/core';
import { IceNavService } from '../../../../projects/icemedx-lib/src/components/ice-nav/ice-nav.service';
import { BaseAppService } from '../../../../projects/icemedx-lib/src/services/baseapp.service';
import { DomainService } from 'projects/icemedx-lib/src/services/domain/domain.service';
import { IceTypes } from 'projects/icemedx-lib/src/models/icetypes';
import { LoginService } from 'projects/icemedx-lib/src/login/login.service';
import { BreadcrumbService } from '../../../icemedx-lib/src/services/breadcrumb/breadcrumb.service';

@Injectable()
export class AppService extends BaseAppService {

  constructor(navSvc: IceNavService, domainSvc: DomainService, loginSvc: LoginService, app: ApplicationRef, breadcrumbSvc: BreadcrumbService) {
    super(navSvc, domainSvc, loginSvc, app, breadcrumbSvc);
  }

  public defaultMenus() {
    super.defaultMenus();
    let navSvc: IceNavService = super.getNavService();
    let curActType: IceTypes.ACCOUNT_TYPE = this.getCurrentAccountType();

    if (this.getMainAppChildMode() == false) {
      navSvc.insertSideRoute(null, "dashboard", null, "dashboard", "Dashboard", "fas fa-tachometer-alt", 0);
      let ptact: string = this.getCurrentPatient();
      let domain: string = this.getCurrentAccount();

      let loginSvc = this.getLoginService();
      let usrInfo = loginSvc.GetSessionUserInfo();

      switch (curActType) {
        case IceTypes.ACCOUNT_TYPE.actFacility:
        case IceTypes.ACCOUNT_TYPE.actProvider:
        case IceTypes.ACCOUNT_TYPE.actPharmacy:
        case IceTypes.ACCOUNT_TYPE.actPayer: {
          this.homeMenu();
          break;
        }
      }

      switch (curActType) {
        case IceTypes.ACCOUNT_TYPE.actPayer: {
          this.payerdomainMenus();
          break;
        }
        case IceTypes.ACCOUNT_TYPE.actPharmacy: {
          this.pharmacydomainMenus();
          break;
        }
        case IceTypes.ACCOUNT_TYPE.actProvider:
        case IceTypes.ACCOUNT_TYPE.actFacility: {
          this.providerdomainMenus();
          break;
        }
      }

      this.groupAdminMenus();
    } else {
      navSvc.showTopMenuParent(navSvc.topMenuMessagesParentElementID, false);
      navSvc.showTopMenuParent(navSvc.topMenuLogoutParentElementID, false);
    }
  }
}
